import React, { FC } from 'react'

import { Wrap } from './styled'

import { LoadingIcon } from 'src/components/Icons'

interface Props {
  color: string
  label: string
  wtfispp?: boolean
  disabled?: boolean
  onClick?: () => void
  loading?: boolean
  city?: boolean
}

export const ModalButton: FC<Props> = ({
  color,
  label,
  wtfispp,
  children,
  disabled,
  onClick,
  loading,
  city,
}) => (
  <Wrap
    color={color}
    wtfispp={wtfispp}
    disabled={disabled}
    onClick={onClick}
    city={city}
  >
    {children}
    {loading && <LoadingIcon />}
    {!loading && <p>{label}</p>}
  </Wrap>
)
